<template>
	<div class="ptlr-60-16 box-s container" :class="{'pb-30': padShow }">
		<div class="bg_f ps_top">
			<NavList :navList="navList" @getItem="getItem"></NavList>
		</div>
    <ul>
		<li class="list_every pd-16-18 box-s mb-16 pra_every" v-for="(item, index) in list" :key="index">
			<div class="flexs flex-jus">
				<div class="flexs">
					<img class="wh_46 b-radius-50 mr-10" src="../../assets/img/icon/practicelist_icon.png" alt="">
					<div class="fw-500 fz-16 c1">{{item.daily_study_type == 1?'每日一练':'加强练习'}}</div>
				</div>
				<div class="flexs bg_ec whl-74-24 flex-center fw-500 fz-12 b-radius-12 c0" :class="{ 'orange_sty': item.lock_status == 2 }" @click="statrPractive(item, index)"> 
					{{item.lock_status == 0? '开始练习':item.lock_status == 1?'再次练习': '立即解锁'}}
					<img v-if="item.lock_status != 2" class="wh_4_6 ml-5" src="../../assets/img/icon/blue_right_arrow.png" alt="">
					<img v-else class="wh_4_6 ml-5" src="../../assets/img/icon/orange_suo.png" alt="">
				</div>
			</div>

			<div class="fw-500 fz-14 c1 pd-16 box-s bg_f9 b-radius-6 mtb-16">题目数量： {{item.question_number}}题</div>

			<div class="flexs">
				<div class="flex1 pl-14 box-s">
					<div class="mb-14 fz-12 c1">练习时间</div>
					<div class="fz-14 c3">{{item.study_day}}</div>
				</div>
				<div class="flex1 pl-14 box-s">
					<div class="mb-14 fz-12 c1">练习情况</div>
					<div class="fz-14 c9" :class="{ 'c10': item.lock_status == 1 }">{{item.lock_status == 0? '未练习':item.lock_status == 1?'已完成': '未解锁'}}</div>
				</div>
			</div>
		</li>
	</ul>

	<div class="btn_contain">
      <div class="card_btn" @click="$router.push('/mypracticelist')">
        我的练习
      </div>
    </div>

		<shareBg v-if="showShare" @hideShare="shareBtn"></shareBg>
    	<shareOk v-if="showShareOk" @hideShare="shareBtnOk" :integral="integral"></shareOk>	
		<noData v-if="show"></noData>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>

	import { dailyStudyIndex, unlockReinforce, userShare , gateLevelSubject} from '@/api/api'
	import {getShowPadding, getShare} from "@/utils/common.js";
	import shareBg from '@/components/shareBg.vue';
  	import shareOk from '@/components/shareOk.vue';
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	import NavList from '@/components/navList'
	export default {
		components: {
			shareBg,
			shareOk,
			noData,
			loading,
			NavList
		},
		data() {
			return {
				padShow: false,
				list: [],
				showShare: false,//分享组件展示
				navList: [],
				showShareOk: false,//分享成功组件展示
				show: false,
				id: '',//点中项id
				index: '',//点中项index
				integral: 1,
				loadFlag: false,
			};
		},
		created() {
			getShare().then(async()=>{
				const res = await unlockReinforce({ dailyStudyId: this.id })
				if(res.code == 1000){
					const res1 = await userShare({ type: '2' })
					if(res1.code == 1000){
						this.showShare = false
						this.showShareOk = true
						this.integral = res1.data.integral
						this.list[this.index].lock_status = 0
					}
				} else {
					this.$toast(res.msg)
				}
			}).catch(()=>{})
				//this.initData()
				this.initSubJectData()
			},
		mounted(){
			this.padShow = getShowPadding()
		},
		methods: {
			// 初始化科目列表
			async initSubJectData(){
				const res = await gateLevelSubject()
				if( res.code == 1000 ){
				this.navList = res.data
					this.initData(this.navList[0].id)
				} else {
					this.$toast(res.msg)
				}
			},
			// 切换导航
			getItem(data){
				this.show = false
				this.initData(data.item.id)
			},
		 	async initData(subject_id){
				this.loadFlag = true
        		const res = await dailyStudyIndex({ subject_id })
				this.loadFlag = false
				console.log(res)
				if(res.code == 1000){
          			this.list = res.data
					if(this.list.length == 0){
						this.show = true
					}
				} else {
            		this.$toast(res.msg)
          		}
			},
			async statrPractive(item,index){
				console.log(88776)
				this.id = item.id
				this.index = index
				if(item.lock_status == 2){
					const res = await unlockReinforce({ dailyStudyId: this.id })
					if(res.code == 1000){
						//this.showShare = true
						this.$router.push({ path: '/startpractice', query: { id: this.id } })
					} else {
						this.$toast(res.msg)
					}
          
				} else {
          			this.$router.push({ path: '/startpractice', query: { id: this.id } })
				}
				
			},

			// 分享的积分
			shareBtn() {
				this.showShare = !this.showShare
			},
			// 恭喜的积分
			shareBtnOk(){  
				this.showShareOk = !this.showShareOk
			}

		}

		
	};
</script>
<style lang="less" scoped>

.orange_sty {
	background: #FFF4EA;
	color: #FFAB5A;
}

.cf {
	color: #497CFF !important;
	box-shadow: 0px 2px 4px 0px rgba(255, 255, 255, 1);
}

.pra_every:last-child {
	margin-bottom: 0;
}
</style>
